// 基座发送事件集合
import Vue from 'vue';

// 数据通信
export const eventBus = new Vue();

export const GTR_SEND_EVENT_LIST = [
  'GTR_EVENT_SEND_MENU_IS_COLLAPSE', // 侧边开启关闭状态
  'GTR_EVENT_SEND_MICRO_APP_AFTER_MOUNT', // 子应用加载完成事件
  'GTR_LISTEN_EVENT_PERMISSION_NOTIFY', // 无权限提示弹窗
  'GTR_EVENT_SEND_DRIVER', // 加特兰指引示例原生实践透传
];
// 基座监听实践集合
export const GTR_LISTEN_EVENT_LIST = [
  'GTR_LISTEN_EVENT_PERMISSION_NOTIFY', // 无权限提示弹窗
  'GTR_LISTEN_EVENT_COUNTRY_SWITCH_DIALOG', // 国家切换对话框
  'GTR_LISTEN_EVENT_PERMISSION_PAGES', // 无权限页面
  'GTR_LISTEN_EVENT_APPLY_ROLE_DEAWER', // 申请角色列表
];
// 基座发送事件方法实例
export const gtrSendEvents = GTR_SEND_EVENT_LIST.reduce((accu, eventName) => {
  accu[eventName] = (config) => {
    eventBus.$emit(eventName, config);
  };
  return accu;
}, {});
/**
 * // 基座监听事件方法实例
 * @type {{}}
 */
export const gtrListenEvents = GTR_LISTEN_EVENT_LIST.reduce((accu, eventName) => {
  accu[eventName] = (callback) => {
    eventBus.$on(eventName, callback);
  };
  return accu;
}, {});
